import * as React from 'react';

function SvgDailyPriceCalcConvertedWeekly(props) {
  return (
    <svg width={48} height={48} fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M24 25.688c-1.978 0-3.839.768-5.236 2.17a7.342 7.342 0 00-2.17 5.236v6.281h14.812v-6.281c0-1.978-.768-3.84-2.17-5.236A7.343 7.343 0 0024 25.688zm-7.406-10.782c0 1.978.768 3.84 2.17 5.236A7.342 7.342 0 0024 22.312a7.342 7.342 0 005.236-2.17 7.342 7.342 0 002.17-5.236V8.625H16.594v6.281z"
        fill="transparent"
      />
      <path d="M34.781 14.906V8.625h4.032a.376.376 0 00.374-.375V5.625a.376.376 0 00-.374-.375H9.186a.376.376 0 00-.374.375V8.25c0 .206.168.375.374.375h4.032v6.281A10.77 10.77 0 0018.206 24a10.77 10.77 0 00-4.987 9.094v6.281H9.188a.376.376 0 00-.376.375v2.625c0 .206.17.375.376.375h29.624a.376.376 0 00.376-.375V39.75a.376.376 0 00-.376-.375h-4.03v-6.281A10.77 10.77 0 0029.793 24a10.77 10.77 0 004.987-9.094zm-3.375 18.188v6.281H16.594v-6.281c0-1.978.768-3.84 2.17-5.236A7.342 7.342 0 0124 25.688c1.978 0 3.84.768 5.236 2.17a7.342 7.342 0 012.17 5.236zm0-18.188c0 1.978-.768 3.84-2.17 5.236A7.342 7.342 0 0124 22.312a7.342 7.342 0 01-5.236-2.17 7.342 7.342 0 01-2.17-5.236V8.625h14.812v6.281z" />
    </svg>
  );
}

export default SvgDailyPriceCalcConvertedWeekly;
